import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=445d551a"
import script from "./SocialLogin.vue?vue&type=script&lang=ts"
export * from "./SocialLogin.vue?vue&type=script&lang=ts"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=445d551a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VBtn,VCol,VContainer,VFlex,VSheet})
